module.exports = __webpack_public_path__ + "54cf98f5/img/arrow-left-icon.785c715c.svg";